/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { log, toast } from '../../utils/notification';
import request from '../../request/request';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const runDynamicQuery = async (params: any, widgetData: any) => {

  const res = await request<Request.Query, any>(true, 'POST', 'services/widgets/data', { data: JSON.stringify({params, widgetData}) });

  if (res.data.error && res.data.message) {
    toast.error('dynamic query', res.data.message);
  }


  log(
    `${widgetData.widget}  ${widgetData.key}`,
    {
      params: params,
      response: res.data
    },
    res.data.error ? 'Error' : 'Widget'
  );
  
  return res.data;

};